import { render, staticRenderFns } from "./SGPostgresConfigSummary.vue?vue&type=template&id=7c9d1db2"
import script from "./SGPostgresConfigSummary.vue?vue&type=script&lang=js"
export * from "./SGPostgresConfigSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports